import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/doubleQuotes.png'


const _withScopeId = n => (_pushScopeId("data-v-0506dcb7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "box_bg_normal" }
const _hoisted_2 = ["scr"]
const _hoisted_3 = {
  key: 1,
  id: "box_title"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "box_icon",
  src: _imports_0
}, null, -1))
const _hoisted_5 = ["id"]
const _hoisted_6 = ["v-if"]
const _hoisted_7 = ["v-if"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BoxWithBtn = _resolveComponent("BoxWithBtn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.item.img)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          id: "box_img",
          scr: require(`@/assets/${_ctx.item.img}`)
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.item.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.item.title), 1))
      : _createCommentVNode("", true),
    _hoisted_4,
    _createElementVNode("div", {
      id: _ctx.des_bold ? 'box_des_bold' : 'box_des'
    }, _toDisplayString(_ctx.item.des), 9, _hoisted_5),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.ps, (pdes, pi) => {
      return (_openBlock(), _createElementBlock("div", {
        id: "box_des",
        "v-if": _ctx.item.ps,
        key: `box_p_${pi}`
      }, _toDisplayString(pdes), 9, _hoisted_6))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.rules, (rule, j) => {
      return (_openBlock(), _createElementBlock("div", {
        id: "box_rule",
        "v-if": _ctx.item.rules,
        key: `box_rule_${j}`
      }, _toDisplayString(rule), 9, _hoisted_7))
    }), 128)),
    (_ctx.item.btnText)
      ? (_openBlock(), _createBlock(_component_BoxWithBtn, {
          key: 2,
          text: _ctx.item.btnText
        }, null, 8, ["text"]))
      : _createCommentVNode("", true)
  ]))
}